yar<template>
  <div class="rel">
    <v-btn class="absolute-close" depressed dark large color="spiceRed" @click="closeModal">
      <v-icon>close</v-icon>
    </v-btn>
    <v-card class="white">
      <v-toolbar v-if="false" fixed color="white" class="elevation-1">
        <v-toolbar-title class="d-flex logo-inner">
          <img :src="require('@/assets/images/spice-logo.png')" width="200px" alt="Spice Logo">
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <ul class="nav-listing">
          <li>
            <a href title>About Us</a>
          </li>
          <li>
            <a href title>Our Teams</a>
          </li>
          <li>
            <a href title>Join Now</a>
          </li>
          <li>
            <a href title>Contact Us</a>
          </li>
        </ul>
        <v-btn icon fab @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="inner-content mt-2">
        <h1 class="title pb-3">Technology
          <span>Innovation</span>
        </h1>
        <v-layout row wrap>
          <v-flex md7>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>

            <p>Click/Hover the icons below to explore our solutions.</p>
          </v-flex>

          <v-flex md5 xs12 class="text-xs-center">
            <img :src="require('@/assets/images/innovation.jpg')" alt="spice money" width="100%">
          </v-flex>

          <v-flex xs12>
            <ul class="icon-triggers">
              <li
                :class="insurance?'active':''"
                @click="insurance=true; biometricdevices=false; gold=false;recharges=false;mpos=false;"
                @mouseover="biometricdevices=false;insurance=true;mpos=false;gold=false; recharges=false"
              >
                <svg style="width:100%;height:100%" viewBox="0 0 24 24">
                  <path
                    fill="#fff"
                    d="M15,14C12.3,14 7,15.3 7,18V20H23V18C23,15.3 17.7,14 15,14M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12M5,15L4.4,14.5C2.4,12.6 1,11.4 1,9.9C1,8.7 2,7.7 3.2,7.7C3.9,7.7 4.6,8 5,8.5C5.4,8 6.1,7.7 6.8,7.7C8,7.7 9,8.6 9,9.9C9,11.4 7.6,12.6 5.6,14.5L5,15Z"
                  ></path>
                </svg>
              </li>

              <li
                :class="gold?'active':''"
                @click="gold=true;recharges=false;insurance=false;biometricdevices=false;mpos=false;"
                @mouseover="recharges=false;mpos=false; biometricdevices=false;gold=true; insurance=false;"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style="width:100%;height:100%"
                  version="1.1"
                  viewBox="0 -57 512 512"
                >
                  <g id="surface1">
                    <path
                      d="M 211.441406 291.136719 L 154.09375 398 L 357.90625 398 L 300.558594 291.136719 Z M 211.441406 291.136719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 241 0 L 271 0 L 271 60.085938 L 241 60.085938 Z M 241 0 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 348.292969 137.425781 L 408.355469 137.425781 L 408.355469 167.425781 L 348.292969 167.425781 Z M 348.292969 137.425781 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 103.644531 137.425781 L 163.707031 137.425781 L 163.707031 167.425781 L 103.644531 167.425781 Z M 103.644531 137.425781 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 158.875 34.089844 L 201.34375 76.558594 L 180.132812 97.769531 L 137.664062 55.300781 Z M 158.875 34.089844 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 353.121094 34.085938 L 374.335938 55.300781 L 331.867188 97.769531 L 310.652344 76.554688 Z M 353.121094 34.085938 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 263.109375 261.136719 C 292.441406 261.136719 376.109375 261.136719 402.558594 261.136719 L 377.390625 214.261719 L 288.273438 214.261719 Z M 263.109375 261.136719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 109.441406 261.136719 C 160.570312 261.136719 222.484375 261.136719 248.890625 261.136719 L 223.726562 214.261719 L 134.609375 214.261719 Z M 109.441406 261.136719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 325.699219 184.261719 L 300.558594 137.425781 L 211.441406 137.425781 L 186.300781 184.261719 C 205.675781 184.261719 306.464844 184.261719 325.699219 184.261719 Z M 325.699219 184.261719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 146.710938 291.136719 L 57.441406 291.136719 L 0 398 L 119.820312 398 L 161.984375 319.554688 Z M 146.710938 291.136719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                    <path
                      d="M 454.558594 291.136719 L 365.289062 291.136719 L 350.015625 319.554688 L 392.179688 398 L 512 398 Z M 454.558594 291.136719 "
                      style=" fill-rule:nonzero;fill-opacity:1;"
                      stroke="#FFFFFF"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </svg>
              </li>

              <li
                :class="biometricdevices?'active':''"
                @click="recharges=false;gold=false;mpos=false;insurance=false;biometricdevices=true;"
                @mouseover="mpos=false;biometricdevices=true;recharges=false;gold=false;insurance=false;"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  viewBox="0 0 99.115 99.115"
                  style="enable-background:new 0 0 99.115 99.115;"
                  xml:space="preserve"
                  width="100%"
                  height="100%"
                >
                  <g>
                    <path
                      d="M80.713,82.968c-3.056-5.763-2.406-4.225-2.957-7.072c-0.501-2.569-0.249-5.54-0.388-8.615   c-0.208-4.649-0.643-9.535-0.643-13.632c0-3.6-1.503-4.745-2.315-7.072c-1.181-3.388-2.128-6.486-3.729-8.102   c-1.941-1.961-4.069-0.716-4.069-0.716c-1.402-3.629-1.77-4.553-3.246-6.345c-1.418-1.725-3.559-1.492-3.559-1.492   s-1.049-5.209-3.445-7.838c-1.278-1.403-3.913-1.387-4.905-0.907c-0.717,0.349-1.678,1.467-2.684,2.202   c-1.934,1.413-4.267,4.057-4.271,4.062l0,0c0,0-0.396-1.207-1.499-3.363c-0.3-0.586-0.691-1.235-1.119-1.917   c2.238-2.354,3.62-5.529,3.62-9.033C45.504,5.877,39.626,0,32.378,0c-7.251,0-13.126,5.877-13.126,13.128   c0,7.079,5.607,12.834,12.622,13.101c0.622,1.845,1.378,3.858,2.039,5.556c1.232,3.165,2.269,5.748,2.859,9.074   c0.432,2.439,0.177,5.228,0.072,7.558c-0.089,1.978-0.235,3.884-0.464,5.45c-0.313,2.138-0.991,3.64-1.353,4.6   c-0.271,0.717-0.225,1.321-0.225,1.321s-0.498-0.008-1.09,0.186c-0.591,0.195-0.965,0.692-0.965,0.692l-0.983-0.661   c0,0,0.185-0.357,0-0.996c-0.201-0.697-0.552-1.676-1.048-2.987c-0.202-0.535-0.395-1.6-0.553-2.104   c-0.417-1.333-0.967-1.827-0.967-1.827s0.57-1.83-0.194-3.812c-0.801-2.076-2.561-4.868-4.518-6.72   c-1.612-1.526-2.926-1.925-4.32-1.714c-1.735,0.263-2.398,2.273-2.075,4.39c0.195,1.28,0.765,3.001,0.9,3.886   c0.321,2.112-0.844,4.61-0.801,6.066c0.056,1.887,1.039,2.933,1.94,6.919c0.321,1.424,1.251,2.982,1.677,4.613   c0.631,2.41,1.018,4.709,1.298,5.29c1.486,3.076,7.383,6.939,12.86,11.959c3.085,2.828,6.736,2.842,9.258,5.401   c1.545,1.566,2.394,4.186,3.986,6.558c6.6,9.83,25.938,0.226,31.02-7.061C81.435,86.137,81.188,83.865,80.713,82.968z    M20.899,13.128c0-6.34,5.137-11.48,11.478-11.48s11.478,5.14,11.478,11.48c0,2.915-1.095,5.568-2.886,7.593   c-0.511-0.8-1.031-1.625-1.503-2.451c1.051-1.445,1.677-3.218,1.677-5.142c0-4.843-3.925-8.767-8.767-8.768   c-4.842,0-8.766,3.925-8.766,8.768c0,4.198,2.953,7.703,6.895,8.56c0.227,0.805,0.463,1.623,0.708,2.463   c0.038,0.13,0.082,0.269,0.123,0.403C25.484,24.028,20.899,19.115,20.899,13.128z M38.503,16.44   c-1.973-4.005-3.405-8.035-7.116-6.929c-1.109,0.331-2.234,1.444-2.411,3.273c-0.174,1.779,0.277,4.164,0.976,6.864   c-2.649-0.986-4.539-3.529-4.539-6.52c0-3.847,3.118-6.965,6.964-6.965s6.964,3.118,6.963,6.965   C39.34,14.327,39.037,15.455,38.503,16.44z"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </svg>
              </li>
              <li
                :class="mpos?'active':''"
                @click="recharges=false;gold=false;insurance=false;biometricdevices=false; mpos=true"
                @mouseover="biometricdevices=false;mpos=true;recharges=false;gold=false;insurance=false;"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  id="Capa_1"
                  x="0px"
                  y="0px"
                  width="100%"
                  height="100%"
                  viewBox="0 0 612 612"
                  style="enable-background:new 0 0 612 612;"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M459.887,56.471h-39.291V19.645C420.596,8.801,411.795,0,400.951,0H211.052c-10.845,0-19.646,8.801-19.646,19.645v36.828   h-39.29c-25.329,0-45.839,20.522-45.839,45.839v463.849c0,25.316,20.508,45.839,45.839,45.839h307.769   c25.328,0,45.838-20.522,45.838-45.839V102.31C505.725,77.008,485.215,56.471,459.887,56.471z M358.389,102.31V56.471V39.291h22.92   v17.183v45.839v43.376h-22.92V102.31z M230.699,102.31V56.471V39.291h72.03v17.183v45.839v43.376h-72.03V102.31L230.699,102.31z    M242.708,558.226c0,10.856-8.801,19.646-19.646,19.646h-31.654c-10.845,0-19.646-8.789-19.646-19.646V524.41   c0-10.856,8.801-19.645,19.646-19.645h31.654c10.845,0,19.646,8.788,19.646,19.645V558.226L242.708,558.226z M242.708,459.451   c0,10.856-8.801,19.645-19.646,19.645h-31.654c-10.845,0-19.646-8.788-19.646-19.645v-33.815c0-10.856,8.801-19.646,19.646-19.646   h31.654c10.845,0,19.646,8.789,19.646,19.646V459.451L242.708,459.451z M242.708,360.69c0,10.856-8.801,19.646-19.646,19.646   h-31.654c-10.845,0-19.646-8.789-19.646-19.646v-33.827c0-10.857,8.801-19.646,19.646-19.646h31.654   c10.845,0,19.646,8.788,19.646,19.646V360.69L242.708,360.69z M341.48,558.226c0,10.856-8.801,19.646-19.645,19.646h-31.667   c-10.845,0-19.645-8.789-19.645-19.646V524.41c0-10.856,8.8-19.645,19.645-19.645h31.667c10.844,0,19.645,8.788,19.645,19.645   V558.226z M341.48,459.451c0,10.856-8.801,19.645-19.645,19.645h-31.667c-10.845,0-19.645-8.788-19.645-19.645v-33.815   c0-10.856,8.8-19.646,19.645-19.646h31.667c10.844,0,19.645,8.789,19.645,19.646V459.451z M341.48,360.69   c0,10.856-8.801,19.646-19.645,19.646h-31.667c-10.845,0-19.645-8.789-19.645-19.646v-33.827c0-10.857,8.8-19.646,19.645-19.646   h31.667c10.844,0,19.645,8.788,19.645,19.646V360.69z M440.244,558.226c0,10.856-8.801,19.646-19.646,19.646h-31.654   c-10.844,0-19.645-8.789-19.645-19.646V524.41c0-10.856,8.801-19.645,19.645-19.645h31.654c10.846,0,19.646,8.788,19.646,19.645   V558.226z M440.244,459.451c0,10.856-8.801,19.645-19.646,19.645h-31.654c-10.844,0-19.645-8.788-19.645-19.645v-33.815   c0-10.856,8.801-19.646,19.645-19.646h31.654c10.846,0,19.646,8.789,19.646,19.646V459.451z M440.244,360.69   c0,10.856-8.801,19.646-19.646,19.646h-31.654c-10.844,0-19.645-8.789-19.645-19.646v-33.827c0-10.857,8.801-19.646,19.645-19.646   h31.654c10.846,0,19.646,8.788,19.646,19.646V360.69z M440.244,245.979c0,18.531-15.035,33.554-33.566,33.554H205.319   c-18.531,0-33.554-15.023-33.554-33.554v-34.666c0-18.546,15.023-33.566,33.554-33.566h201.358   c18.531,0,33.566,15.023,33.566,33.566V245.979z"
                      fill="#FFFFFF"
                    ></path>
                  </g>
                </svg>
              </li>
            </ul>
          </v-flex>
        </v-layout>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="insurance">
            <v-flex xs12>
              <h2>Insurance</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="recharges">
            <v-flex xs12>
              <h2>Recharge your mobile phone</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>We offer recharge services for all major recharge operators like Airtel, !dea, Vodafone, JiO, BSNL, TATA etc.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="gold">
            <v-flex xs12>
              <h2>Digital Gold</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Gold - your friend in all times. India has always been biggest lover of Gold and Gold have always</p>
            </v-flex>
          </v-layout>
        </transition>

        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="biometricdevices">
            <v-flex xs12>
              <h2>Biometric Devices</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed enim mauris, luctus a justo sed, viverra bibendum nisl. Pellentesque facilisis dolor eget facilisis consequat. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. In ultricies, ligula vel eleifend tristique, justo massa scelerisque sapien, eu dictum risus leo in nisi. Morbi odio ante, sollicitudin sed finibus vel, bibendum id magna. Phasellus suscipit fringilla neque, id sollicitudin odio tincidunt ac. Curabitur vel interdum neque. Sed ornare mi diam, at placerat leo mattis quis. Duis rutrum elit nisi, quis pharetra leo maximus non. In hac habitasse platea dictumst. Sed maximus leo est, nec accumsan tellus fringilla a. Nulla tincidunt dui imperdiet ultrices porttitor. Pellentesque ut vestibulum neque, et malesuada nibh. Pellentesque mi dui, gravida et gravida at, accumsan nec lorem. Nunc id lacinia urna. Sed sed arcu justo.</p>
            </v-flex>
          </v-layout>
        </transition>
        <transition name="fadeY" mode="out-in">
          <v-layout row wrap py-5 v-if="mpos">
            <v-flex xs12>
              <h2>MPOS Devices</h2>
            </v-flex>
            <v-flex md12 xs12>
              <p>Currently, only 3 million Point of Sale (POS) machines facilitates Debit/ Credit Card payment to Merchants. Spice Money Aadhaar Pay Solution for small merchant will enable over 660million+ Aadhaar linked bank account holders to transact card-less transaction across merchant locations which will solve the hassles of customer to carry his/her phone, debit card, credit card, remember PIN with “Nil” MDR.
                <em>The Merchant will also have a low-cost option of accepting payment card using a Mobile POS.</em>
              </p>
            </v-flex>
          </v-layout>
        </transition>
      </v-card-text>
    </v-card>
  </div>
</template>

<style scoped>
.v-toolbar__title {
  color: #2a3997 !important;
}
.title {
  text-transform: uppercase;
  font-size: 64px !important;
  color: #000;
  font-weight: 100;
}
.title span {
  font-weight: 900;
}
h2 {
  font-size: 30px;
  padding-bottom: 15px;
}
p {
  font-size: 15px;
  line-height: 20px;
  margin-bottom: 10px;
  color: #333;
}

.content-img {
  -webkit-box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
  box-shadow: 0 5px 20px 0 rgba(54, 57, 73, 0.09);
}
.logo-inner {
  align-items: center;
}
.nav-listing {
  list-style: none;
  display: flex;
  flex-direction: row;
}
.nav-listing li {
  margin-left: 10px;
}
.nav-listing li a {
  text-decoration: none;
  padding: 10px 15px;
  transition: all ease-in-out 0.2s;
  color: #475055;
  font-size: 16px;
}
.nav-listing li a:hover,
.nav-listing li a.active {
  color: #4385f3;
}
.inner-content {
  padding: 70px;
}

.icon-triggers {
  list-style: none;
  margin: 0;
  padding: 30px 0 0 0;
}
.icon-triggers li {
  position: relative;
  cursor: pointer;
  display: inline-block;
  color: #ff7a00;
  border: 3px solid #ff7a00;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  line-height: 0;
  padding: 1.9em;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  width: 120px;
  height: 120px;
  margin-right: 7%;
  animation: categoryTriggerPulse 3s infinite;
}

.icon-triggers li:before,
.icon-triggers li:after {
  content: "";
  display: block;
  position: absolute;
  width: 120%;
  height: 120%;
  top: -10%;
  left: -10%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  opacity: 0;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(180deg);
}

.icon-triggers li:before {
  border: 2px solid #ff7a00;
}

.icon-triggers li.active,
.icon-triggers li:hover {
  background-color: rgb(255, 122, 0);
  color: #fff;

  animation: none;
}
.icon-triggers path {
  transition: all ease-in-out 0.6s;
}
.icon-triggers li path,
.icon-triggers li path {
  fill: rgb(255, 122, 0);
}

.icon-triggers li.active path,
.icon-triggers li:hover path {
  fill: #fff;
}

.icon-triggers li.active:hover {
  cursor: default;
}

.icon-triggers li:not(.active):hover:before {
  border-top-color: #ff7a00;
  border-right-color: #ff7a00;
  border-bottom-color: #ff7a00;
  -webkit-transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
  transition: border-top-color 0.15s linear,
    border-right-color 0.15s linear 0.1s, border-bottom-color 0.15s linear 0.2s;
}

.icon-triggers li:not(.active):hover:after {
  border-top: 3px solid #ff7a00;
  border-left-width: 2px;
  border-right-width: 2px;
  -webkit-transform: rotate(540deg);
  -ms-transform: rotate(540deg);
  transform: rotate(540deg);
  -webkit-transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s;
  transition: transform 0.4s linear 0s, border-left-width 0s linear 0.35s,
    -webkit-transform 0.4s linear 0s;
}

.icon-triggers li:hover:after {
  opacity: 1;
}

@-webkit-keyframes categoryTriggerPulse {
  0% {
    -webkit-box-shadow: 0 0 0 0 rgb(255, 122, 0, 0.8);
  }
  50% {
    -webkit-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -webkit-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

@keyframes categoryTriggerPulse {
  0% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0.8);
  }
  50% {
    -moz-box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 15px rgba(255, 122, 0, 0);
  }
  100% {
    -moz-box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
    box-shadow: 0 0 0 0 rgba(255, 122, 0, 0);
  }
}

.standard-listing {
  color: #ff7a00;
}
.standard-listing li {
  float: left;
  width: 50%;
}
</style>

<script>
import TechnologyDetails from "./TechnologyDetails.ts";
export default TechnologyDetails;
</script>